function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.5,
  cy: 17.5,
  r: 17,
  fill: "white",
  stroke: "#009658"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.1666 12.5L14.9999 21.6667L10.8333 17.5",
  stroke: "#009658",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgCompletedFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedFilled);
export default __webpack_public_path__ + "static/media/Completed_Filled.b14c571f73feb1312ee9cb5064a00f04.svg";
export { ForwardRef as ReactComponent };